export type StreamDataChunk<T = unknown> = {
  type: 'data';
  data: T;
};

export type StreamErrorChunk = {
  type: 'error';
  error: unknown;
};

export type StreamChunk<T = unknown> = StreamDataChunk<T> | StreamErrorChunk;

export async function* readJsonlStream<T = unknown>(
  stream: ReadableStream<Uint8Array>
) {
  const decoder = new TextDecoder();
  let buffer = '';

  const reader = stream.getReader();

  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while (true) {
      const { value, done } = await reader.read();

      if (done) {
        buffer += decoder.decode(); // Flush any remaining bytes
      } else {
        buffer += decoder.decode(value, { stream: true });
      }

      let newlineIndex: number;
      while ((newlineIndex = buffer.indexOf('\n')) >= 0) {
        const line = buffer.slice(0, newlineIndex);
        buffer = buffer.slice(newlineIndex + 1);

        if (line.trim()) {
          yield JSON.parse(line) as StreamChunk<T>;
        }
      }

      if (done) break;
    }

    // Handle any remaining data in the buffer
    if (buffer.trim()) {
      yield JSON.parse(buffer) as StreamChunk<T>;
    }
  } finally {
    reader.releaseLock();
  }
}
